export default __webpack_public_path__ + "static/media/logoWithText.b6ef4cd7.png";